module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('h2', {
    staticClass: "chapter-number---IVP sigil_not_in_toc",
    attrs: {
      "id": "_idParaDest-8"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor071"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor072"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor073"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor074"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page9",
      "title": "9"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "chapter-title---IVP",
    attrs: {
      "id": "_idParaDest-9"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor075"
    }
  }), _vm._v("Acknowledgments")]), _vm._v(" "), _c('p', {
    staticClass: "veryfirst"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("T")]), _vm._v("his book (or, in fact, my career) would not have been possible without the people who taught me church history and gave me a love for the church and her tradition. I especially want to thank my first church history professor, James E. Bradley of Fuller Theological Seminary, and my dissertation advisors, Dennis Groh and Robert Jewett of Garrett-Evangelical Theological Seminary. I would also like to thank my colleagues and students at Garrett-Evangelical for their support and trust, as well as my research assistant, Kay Hardiman, who helped with the subject index.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor076"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor077"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page10",
      "title": "10"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bee5018e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/acknowledgements.vue
// module id = 66
// module chunks = 0